import { render, staticRenderFns } from "./menuAccount.vue?vue&type=template&id=9f3afc84&scoped=true"
import script from "./menuAccount.vue?vue&type=script&lang=js"
export * from "./menuAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f3afc84",
  null
  
)

export default component.exports